import { render } from "./FooterUrboStudio.vue?vue&type=template&id=7a50bd4e"
import script from "./FooterUrboStudio.vue?vue&type=script&lang=js"
export * from "./FooterUrboStudio.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__